import { KeyValue } from '@/main/models/common';

export enum ClaimTypeTypes {
  GET_CLAIM_TYPE = '@claimType/GET_CLAIM_TYPE',
  SAVE_CLAIM_TYPE = '@claimType/SAVE_CLAIM_TYPE',
  RESET_REDUCER_CLAIM_TYPE = '@claimType/RESET_REDUCER_CLAIM_TYPE'
}

export interface ClaimTypeState {
  readonly claimType: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetClaimType {
  type: typeof ClaimTypeTypes.GET_CLAIM_TYPE;
}

export interface SaveClaimType {
  type: typeof ClaimTypeTypes.SAVE_CLAIM_TYPE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerClaimType {
  type: typeof ClaimTypeTypes.RESET_REDUCER_CLAIM_TYPE;
}

export type ClaimTypeActionTypes =
  | GetClaimType
  | SaveClaimType
  | ResetReducerClaimType;

